import ProfileLayout from '@src/layout/profile/layout.vue'
import store from '@src/store'

import { Route } from '../ARoute'

let profilePage = () =>
  import(
    /* webpackChunkName: "view-profile" */ `@src/views/profile/profile-main.vue`
  )
let passwordPage = () =>
  import(
    /* webpackChunkName: "view-profile" */ `@src/views/profile/profile-password.vue`
  )
export default Route.withPath('/ho-so', ProfileLayout)
  .withOption({
    meta: { title: 'title.profile' },
  })
  .withAuth()
  .onBeforeEnter(beforeEnter)
  .withChildren(
    Route.group(
      {
        namespace: 'profile',
      },
      [
        Route.withPath('', profilePage),
        Route.withPath('mat-khau', passwordPage).withName('password'),
      ]
    )
  )
const beforeEnter = async (to, from, next) => {
  try {
    await store.dispatch('auth/getInfo')
    let currentUser = store.getters['auth/currentUser']
    if (!currentUser || !currentUser.id) {
      throw new Error('not login')
    } else {
      next()
    }
  } catch (error) {
    window.location.href = '/'
  }
}
